import { shallowEqual } from 'react-redux'
import { genderStatisticsType } from '../../../../_constants/Code'
import { useSecuritiesReportDispatch, useSecuritiesReportSelector } from '../extra/store'
import _get from 'lodash/get'
import { ErrorComponent } from './ErrorComponent'

const FormInput = (props) => {
  const {
    className = '',
    id = '',
    name = '',
    isError = false,
    placeholder = '入力してください',
    onChange = null,
    value
  } = props
  return (
    <div className="form-control px-3 py-2">
      <input
        data-testid={props?.['data-testid']}
        className={`text-input min-h-[46px] text-left text-base  w-full ${className} ${isError && 'is-error'}`}
        type="text"
        id={id}
        value={value}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  )
}

const employeeCountUrl = '/master/dashboard/employeeCountInfo'

const genderStatsList = Object.entries(genderStatisticsType).filter(([k]) => k !== 'Excluded')
const convertPascalToCamel = (s) => s.slice(0, 1).toLowerCase() + s.slice(1)

const genderStatisticsTypeList = genderStatsList.map(([k, v]) => ({
  key: convertPascalToCamel(k),
  ...v
}))

/**
 * @function GenderStatsCategorySetting
 * @type {React.FC}
 */
const GenderStatsCategorySetting = () => {
  const companyConfig = useSecuritiesReportSelector(
    (s) => _get(s, ['pageState', s.selectedFiscalYear, 'companyConfig']),
    shallowEqual
  )

  const clientErrors = useSecuritiesReportSelector((s) => s.errors.client)

  const dispatch = useSecuritiesReportDispatch()

  const updateGenderStatsState = (key) => (e) => {
    const value = e.target.value

    dispatch('SET_COMPANY_CONFIG', {
      path: key,
      value
    })
  }

  const genderStatTypeText = genderStatsList.map(([, v]) => `"${v.name}"`).join('、')

  const genderStatisticsKeys = genderStatisticsTypeList.map((e) => e.key)

  return (
    <>
      <h2 className="text-body-2-bold grow ">■ジェンダー統計区分設定</h2>
      <p className="mt-5">ジェンダー統計区分の表示名を設定してください。</p>
      <p>CHROFY規定値（{genderStatTypeText}）を貴社設定値に読み替えて表示できます。</p>
      <p>未設定の場合は、CHROFY規定値で表示されます。</p>
      <p>
        各ジェンダー統計区分に対応する雇用区分は、
        <a className="text-blue-500" href={employeeCountUrl} target="_blank">
          人数カウント設定画面
        </a>
        で設定してください。
      </p>

      <div className="setting-table max-w-[90%] mt-5">
        <table className="base-table table-fixed w-full">
          <thead>
            <tr>
              {genderStatisticsTypeList.map((e, index) => (
                <th key={e.key + 'headers' + index}>{e.name}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              {genderStatisticsTypeList.map((e, index) => (
                <td key={e.key + 'row' + index}>
                  <FormInput
                    placeholder={`${e.name}を入力してください`}
                    id={e.key}
                    name={e.key}
                    data-testid={e.key}
                    value={companyConfig?.[e.key]}
                    onChange={updateGenderStatsState(e.key)}
                  />
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        <div className="mt-3">
          <ErrorComponent errors={clientErrors} errorKeys={genderStatisticsKeys} />
        </div>
      </div>
    </>
  )
}

export default GenderStatsCategorySetting
